import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuestionarioComponent } from './questionario.component';
import { ComentariosComponent } from './comentarios/comentarios.component';

const routes: Routes = [
    {
      path: '',
      component: QuestionarioComponent,
      children: [
        { path: 'comentario', component: ComentariosComponent }
      ],
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class QuestionarioRoutingModule {}
